import { BaseObserver } from '@journeyapps-labs/common-utils';
import { v4 } from 'uuid';
import { computed, observable } from 'mobx';

export enum NotificationType {
  SUCCESS = 'success',
  ERROR = 'error'
}

export interface NotificationListener {
  disposed: () => void;
}

export interface NotificationOptions {
  type: NotificationType;
  desc: string;
}

export class Notification extends BaseObserver<NotificationListener> {
  id: string;

  private timerResource: NodeJS.Timeout;

  constructor(public options: NotificationOptions) {
    super();
    this.id = v4();
  }

  init() {
    this.timerResource = setTimeout(() => {
      this.dispose();
    }, 4000);
  }

  dispose() {
    clearTimeout(this.timerResource);
    this.iterateListeners((cb) => cb.disposed?.());
  }
}

export class NotificationStore {
  @observable
  protected accessor _notifications: Map<string, Notification>;

  constructor() {
    this._notifications = new Map();
  }

  @computed get notifications(): Notification[] {
    return Array.from(this._notifications.values());
  }

  showNotification(notification: Notification) {
    this._notifications.set(notification.id, notification);
    notification.init();
    let l1 = notification.registerListener({
      disposed: () => {
        l1();
        this._notifications.delete(notification.id);
      }
    });
  }
}
